import { Accordion, AccordionDetails, AccordionSummary, Box, Divider, Typography, useTheme } from '@mui/material';
import { IInstrumento } from '../../../services/api/dams/DamServices';
import { ExpandMoreOutlined } from '@mui/icons-material';

interface InstrumentConsolidatedProps {
    data: IInstrumento[] | undefined;
}

export const InstrumentConsolidated = ({data}: InstrumentConsolidatedProps) => {

    const theme = useTheme();

    function countInstrumentTypes(instrumentos: IInstrumento[]): Record<string, number> {
        return instrumentos.reduce((countArray: Record<string, number>, instrumento: IInstrumento) => {
            const tipo = instrumento.tipo_instrumento;
            countArray[tipo] = (countArray[tipo] || 0) + 1;
            return countArray;
        }, {});
    }

    if(data == undefined){
        return(
            <Box>
                <Typography>Sem instrumentos</Typography>
            </Box>
        );
    }
    
    return(
        <Accordion
            variant='outlined'
            square={true}  sx={{borderRadius: '30px', '&:before': {display: 'none',}}} disableGutters
                            >
            <AccordionSummary
                expandIcon={<ExpandMoreOutlined sx={{color: theme.palette.primary.contrastText}}/>}
            >
                <Typography><strong>Instrumentos</strong></Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Box flex={1} flexDirection={'row'} display={'flex'} gap={1}>
                    {data.length > 0 ? (
                        <ul>
                            {
                                Object.entries(countInstrumentTypes(data)).map(([type, count], index) => (
                                    <li key={index}>
                                        <Typography variant="subtitle1">{`${type}: ${count}`}</Typography>
                                        <Divider/>
                                    </li>
                                ))
                            }
                        </ul>
                    ): null}
                </Box>
            </AccordionDetails>
        </Accordion>
    );
};